import { jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { c as clsx } from "../../../chunks/clsx-DgYk2OaC.js";
import { Icon } from "../../../foundations/icons/Icon.js";
import { FocusRing } from "../../../library/react-aria/FocusRing.js";
import { $ as $701a24aa0da5b062$export$ea18c227d4417cc3 } from "../../../chunks/useButton-BIR5vkbu.js";
const iconButton = "_iconButton_1y3u9_1";
const styles = {
  iconButton,
  "iconButton-primary": "_iconButton-primary_1y3u9_19",
  "iconButton-primary--pressed": "_iconButton-primary--pressed_1y3u9_31",
  "iconButton-outline": "_iconButton-outline_1y3u9_40",
  "iconButton-outline--pressed": "_iconButton-outline--pressed_1y3u9_52",
  "iconButton-elevated": "_iconButton-elevated_1y3u9_61",
  "iconButton-elevated--pressed": "_iconButton-elevated--pressed_1y3u9_73",
  "iconButton-ghost": "_iconButton-ghost_1y3u9_82",
  "iconButton-ghost--pressed": "_iconButton-ghost--pressed_1y3u9_94"
};
const IconButtonBase = forwardRef(
  ({ variant = "primary", icon = "XBig", className, onPress, ...props }, ref) => {
    const buttonRef = useRef(null);
    const { buttonProps, isPressed } = $701a24aa0da5b062$export$ea18c227d4417cc3({ onPress, preventFocusOnPress: true }, buttonRef);
    const iconButtonClasses = clsx(
      styles.iconButton,
      styles["iconButton-" + variant],
      {
        [styles["iconButton-" + variant + "--pressed"]]: isPressed
      },
      className
    );
    return /* @__PURE__ */ jsx(FocusRing, { children: /* @__PURE__ */ jsx("button", { ...buttonProps, ref, className: iconButtonClasses, ...props, children: /* @__PURE__ */ jsx(Icon, { variant: icon, "aria-hidden": true }) }) });
  }
);
const IconButton = forwardRef((props, ref) => /* @__PURE__ */ jsx(IconButtonBase, { ...props, ref }));
export {
  IconButton,
  IconButtonBase
};
